import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { cloneDeep, size, sortBy } from 'lodash';
import { withTranslation } from 'react-i18next';
import { GenericInput } from '../../../../components/common';
import PricesForm from './DiscountingForm';
import PricesFormRecurringTiered from './PricesFormRecurringTiered';
import ModalRateUnit from '../../../../components/common/ModalRateUnit';
import ModalTimeUnit from '../../../../components/common/ModalTimeUnit';
import ModalHolidayUnit from '../../../../components/common/ModalHolidayUnit';

const initAtrr = data => {
  let defaultConfig = [];
  if (data && data.length) {
    defaultConfig = data.map(val => {
      const atrr = val.attribute;
      const indxDot = atrr.indexOf('.');
      if (indxDot) {
        return { selectRecord: atrr.substring(0, indxDot), selectField: atrr.substring(indxDot + 1, atrr.length) };
      }
      return {};
    });
  }
  return defaultConfig;
};
let listConfigUsageTypeService = [];
class DiscountForm extends Component {
  state = {
    dataConfigAttributeBase: [],
    isOpenModalItem: '',
  };

  static getDerivedStateFromProps(props, state) {
    if (state.pricing === props.pricing) return null;
    return {
      pricing: props.pricing || {},
      dataConfigAttributeBase: state.dataConfigAttributeBase.length
        ? state.dataConfigAttributeBase
        : initAtrr(props.pricing.usageAttributeDiscountingData),
    };
  }

  componentDidMount() {
    this.doGetConfigUsageTypeConfig();
  }

  componentDidUpdate() {
    this.doGetConfigUsageTypeConfig();
  }

  doGetConfigUsageTypeConfig = () => {
    const { getConfigUsageTypeConfig, discountingModel, transactionType } = this.props;
    if (
      !listConfigUsageTypeService.length &&
      (discountingModel === 'USAGE_ATTRIBUTE_BASED' || (discountingModel === 'COMPLEX' && transactionType === 'USAGE'))
    ) {
      getConfigUsageTypeConfig('', ({ data }) => {
        if (data) listConfigUsageTypeService = data?.configUsageTypeService || [];
      });
    }
  };

  onChangePricing = () => {
    const { pricing } = this.state;
    const { onChangePricing, index } = this.props;
    onChangePricing(index, pricing);
  };

  handleChangePrice = (idx, data) => {
    const { pricing } = this.state;
    pricing.discounts[idx] = data;
    this.setState({ pricing }, () => this.onChangePricing());
  };

  handleChangeTier = (idx, data) => {
    const { pricing } = this.state;
    pricing.tiers[idx] = data;
    this.setState({ pricing }, () => this.onChangePricing());
  };

  handleRemovePricing = e => {
    e.preventDefault();
    const { onRemovePricing, index, pricing } = this.props;
    if (onRemovePricing) {
      onRemovePricing(index, pricing);
    }
  };

  onChangePricingProps = ({ name, value }) => {
    const { pricing } = this.state;
    pricing[name] = value;
    this.setState({ pricing }, () => this.onChangePricing());
  };

  handleRemovePrice = (priceIdx, price) => {
    const { pricing } = this.state;
    if (pricing.discounts && pricing.discounts[priceIdx] >= 0) {
      pricing.discounts.splice(priceIdx, 1);
    }
    this.setState({ pricing }, () => this.onChangePricing());
  };

  onChangeSubInputRecurringTirred = ({ name, value }) => {
    const { pricing } = this.state;
    pricing.tierDiscounting[0][name] = value;
    this.setState({ pricing }, () => this.onChangePricing());
  };

  onChangeSubInputUsageAttributeBase = ({ name, value, idxPrice }) => {
    const { dataConfigAttributeBase, pricing } = this.state;
    const newPricing = pricing;
    const newDataConfig = dataConfigAttributeBase;
    if (!newDataConfig[idxPrice]) newDataConfig[idxPrice] = {};
    newDataConfig[idxPrice][name] = value;
    const newUsageAttributePricingData = cloneDeep(newPricing.usageAttributeDiscountingData);
    if (newDataConfig[idxPrice] && newDataConfig[idxPrice].selectRecord && newDataConfig[idxPrice].selectField) {
      newUsageAttributePricingData[
        idxPrice
      ].attribute = `${newDataConfig[idxPrice].selectRecord}.${newDataConfig[idxPrice].selectField}`;
    } else {
      newUsageAttributePricingData[idxPrice].attribute = '';
    }
    newPricing.usageAttributeDiscountingData = newUsageAttributePricingData;
    this.setState({ dataConfigAttributeBase: newDataConfig, pricing: newPricing }, () => this.onChangePricing());
  };

  onChangeAttributeBaseProps = ({ name, value, idxPrice }) => {
    const { pricing } = this.state;
    pricing.usageAttributeDiscountingData[idxPrice][name] = value;
    this.setState({ pricing }, () => this.onChangePricing());
  };

  onChangeTierRecurring = (idx, data) => {
    const { pricing } = this.state;
    pricing.tierDiscounting[0].tiers[idx] = data;
    this.setState({ pricing }, () => this.onChangePricing());
  };

  onChangeRecurringPriceStructure = ({ data, idx, index }) => {
    const { pricing } = this.state;
    pricing.tierDiscounting[0].tiers[idx] = data;
    this.setState({ pricing }, () => this.onChangePricing());
  };

  onCopyOldAttributeBase = () => {
    const { pricing } = this.state;
    const { creatingMode } = this.props;
    const lastIdxItem = pricing.usageAttributeDiscountingData.length;
    if (lastIdxItem) {
      // const newItem = pricing.usageAttributeDiscountingData[lastIdxItem - 1];
      const newItem = cloneDeep(pricing.usageAttributeDiscountingData[0]);
      newItem.value = 'NONE';
      if (!creatingMode) {
        newItem.index++;
      }
      pricing.usageAttributeDiscountingData.push(cloneDeep(newItem));
    }
    this.setState({ pricing }, () => this.onChangePricing());
  };

  onHandleRemoveField = ({ idxItem }) => {
    const { pricing } = this.state;
    const { creatingMode } = this.props;
    if (creatingMode) {
      pricing.usageAttributeDiscountingData.splice(idxItem, 1);
    } else {
      pricing.usageAttributeDiscountingData[idxItem] = { index: pricing.usageAttributeDiscountingData[idxItem].index };
    }
    this.setState({ pricing }, () => this.onChangePricing());
  };

  onOpenModal = ({ name }) => {
    this.setState({ isOpenModalItem: name });
  };

  onSelectItem = (row, val) => {
    const { isOpenModalItem } = this.state;
    this.onChangePricingProps({ name: isOpenModalItem, value: row });
    this.setState({ isOpenModalItem: '' });
  };

  onRenderSubinputAttribute = ({
    subInputUsageAtributeBase,
    dataConfigAttributeBase,
    pricing,
    usageContainerRecordList,
    index,
    isComplexUsage,
  }) => {
    const { serviceType } = this.props;
    return (
      subInputUsageAtributeBase &&
      subInputUsageAtributeBase.length > 0 &&
      pricing.usageAttributeDiscountingData &&
      pricing.usageAttributeDiscountingData
        .filter(val => size(val) > 1)
        .map((val, idxPrice) => {
          const itemDefaultConfig = dataConfigAttributeBase[idxPrice];
          const itemRecordSelect = itemDefaultConfig
            ? usageContainerRecordList.filter(val => val.recordType === itemDefaultConfig.selectRecord)
            : [];
          let optionFieldType = [];
          if (itemRecordSelect && itemRecordSelect.length)
            optionFieldType = itemRecordSelect[0].attributes.map(item => ({
              label: item.attributeName,
              value: item.attributeName,
            }));

          const itemOptions = listConfigUsageTypeService.find(i => i.serviceType === serviceType);
          let listOptions = null;
          if (itemOptions && itemOptions.configUsageTypeList) {
            listOptions = itemOptions.configUsageTypeList
              .filter(i => !!i.usagetype)
              .map(i => ({
                label: i.usagetype,
                value: i.usagetype,
              }));
          }
          return (
            <div className="row col-md-12 pb-2" key={`idx-${idxPrice}`}>
              {/* <div className="card-header col-md-12">
                  {`${t('label.index').toUpperCase()}#${idxPrice + 1}`}
      
                </div> */}
              <div className="col-md-12 row p-2">
                <div className="row col-md-11 p-0">
                  {subInputUsageAtributeBase.map((input, idx) => {
                    if (input.name === 'value') {
                      return (
                        <GenericInput
                          key={`pricing-${input.name}-${idx}`}
                          disabled={input.disabled}
                          {...input}
                          value={val[input.name] || null}
                          type={
                            (itemDefaultConfig?.selectField === 'usagetype' ||
                              (val.attribute && val.attribute.indexOf('usagetype'))) &&
                            listOptions
                              ? 'select'
                              : 'text'
                          }
                          options={
                            (itemDefaultConfig?.selectField === 'usagetype' ||
                              (val.attribute && val.attribute.indexOf('usagetype'))) &&
                            listOptions
                              ? listOptions
                              : []
                          }
                          onChange={({ name, value }) => this.onChangeAttributeBaseProps({ name, value, idxPrice })}
                        />
                      );
                    }
                    return (
                      <GenericInput
                        key={`pricing-${input.name}-${idx}`}
                        disabled={input.disabled}
                        {...input}
                        value={
                          ['selectRecord', 'selectField'].indexOf(input.name) > -1
                            ? itemDefaultConfig
                              ? itemDefaultConfig[input.name]
                              : ''
                            : val[input.name]
                        }
                        options={input.name === 'selectField' ? optionFieldType : input.options}
                        onChange={
                          ['selectRecord', 'selectField'].indexOf(input.name) > -1
                            ? ({ name, value }) => this.onChangeSubInputUsageAttributeBase({ name, value, idxPrice })
                            : ({ name, value }) => this.onChangeAttributeBaseProps({ name, value, idxPrice })
                        }
                      />
                    );
                  })}
                </div>
                <div className="col-md-1 m-auto">
                  {pricing.usageAttributeDiscountingData.length > 1 && index === 0 && (
                    <button
                      type="button"
                      className="btn-delete mt-3 float-left pl-4"
                      onClick={() => this.onHandleRemoveField({ idxItem: idxPrice })}
                    >
                      <i className="fa fa-trash" />
                    </button>
                  )}
                </div>
              </div>
            </div>
          );
        })
    );
  };

  render() {
    const {
      index,
      pricingInputs,
      pricingRemoveable,
      priceRemovable,
      creatingMode,
      isComplexUsage,
      subInputRecurringTirred,
      checkModel,
      usageContainerRecordList,
      indexShowing,
      onToggleShowIndex,
      inputFieldsUsageComplex,
      t,
      indexLabel,
      ...props
    } = this.props;
    const { pricing, dataConfigAttributeBase, isOpenModalItem } = this.state;
    const optionRecordType =
      usageContainerRecordList && usageContainerRecordList.length
        ? sortBy(
            usageContainerRecordList.map(val => ({ label: val.recordType, value: val.recordType })),
            ['label']
          )
        : [];
    const subInputUsageAtributeBase =
      props.discountingModel === 'USAGE_ATTRIBUTE_BASED' || props.discountingModel === 'COMPLEX'
        ? [
            {
              label: 'label.selectRecord',
              wrapperClass: 'col-md-3',
              name: 'selectRecord',
              // required: true,
              type: 'select',
              options: optionRecordType,
              disabled: index > 0 && !isComplexUsage,
              menuPortalTarget: true,
            },
            {
              label: 'label.selectField',
              wrapperClass: 'col-md-3',
              name: 'selectField',
              // required: true,
              type: 'select',
              options: [],
              disabled: index > 0 && !isComplexUsage,
              menuPortalTarget: true,
            },
            {
              label: 'label.field',
              wrapperClass: 'col-md-3',
              name: 'attribute',
              required: true,
              readOnly: true,
              disabled: index > 0 && !isComplexUsage,
            },
            {
              label: 'label.value',
              wrapperClass: 'col-md-3',
              name: 'value',
              required: true,
              menuPortalTarget: true,

              // disabled: index > 0,
            },
          ]
        : [];

    if (isComplexUsage && size(pricing) < 11) return '';
    return (
      <div className={props.discountingModel !== 'FLAT' ? 'card pricing-panel' : ''}>
        {props.discountingModel !== 'FLAT' && (
          <button
            type="button"
            className={`card-header text-left no-border btn-collapsible-index ${
              indexShowing === index + 1 ? 'active-main' : ''
            }`}
            onClick={() => onToggleShowIndex(index)}
          >
            {`${t('label.index').toUpperCase()}#${indexLabel + 1}`}
            {indexShowing === index + 1 ? <i className="fa fa-minus" /> : <i className="fa fa-plus" />}
            {(pricingRemoveable || isComplexUsage) && (
              <button type="button" className="btn-rm-card mr-5" onClick={this.handleRemovePricing}>
                <i className="fa fa-trash" />
              </button>
            )}
          </button>
        )}
        <div className={`card-body prc-card ${indexShowing === index + 1 ? 'show-content' : 'hidden-content'}`}>
          <div className="form-row mb-4">
            {subInputRecurringTirred &&
              subInputRecurringTirred.map((input, idx) => {
                return (
                  <GenericInput
                    key={`pricing-${input.name}-${idx}`}
                    {...input}
                    value={pricing && pricing.tierDiscounting && pricing.tierDiscounting[0][input.name]}
                    onChange={this.onChangeSubInputRecurringTirred}
                    disabled={
                      (!creatingMode && (input.name === 'unit' || input.name === 'frequency')) || input.disabled
                    }
                  />
                );
              })}
            {inputFieldsUsageComplex &&
              inputFieldsUsageComplex.map(val => {
                if (!val.title) return '';
                return (
                  <div className="col-md-12 row" key={val.title}>
                    <h5 className="card-title title-form">{t(val.title)}</h5>
                    <div className="col-md-12 row p-0 m-0">
                      {isComplexUsage && val.isRenderSubField && (
                        <div className="col-md-12">
                          {this.onRenderSubinputAttribute({
                            isComplexUsage,
                            subInputUsageAtributeBase,
                            dataConfigAttributeBase,
                            pricing,
                            usageContainerRecordList,
                            index,
                          })}
                          <div className="col-md-12 pt-3 pb-3 text-center">
                            <button
                              type="button"
                              className="button button-border gray x-small"
                              onClick={this.onCopyOldAttributeBase}
                              disabled={index > 0}
                            >
                              {`+ ${t('label.addAnotherField')}`}
                            </button>
                          </div>
                        </div>
                      )}
                      {val.listField &&
                        val.listField.length > 0 &&
                        val.listField.map((input, idx) => {
                          return (
                            <GenericInput
                              key={`pricing-${input.name}-${idx}`}
                              {...input}
                              value={pricing[input.name]}
                              onChange={this.onChangePricingProps}
                              disabled={
                                (!creatingMode && (input.name === 'unit' || input.name === 'frequency')) ||
                                input.disabled
                                // (isComplexUsage && index > 0)
                              }
                              onClick={input.fa ? () => this.onOpenModal({ name: input.name }) : () => {}}
                            />
                          );
                        })}
                    </div>
                  </div>
                );
              })}
            {pricingInputs &&
              pricingInputs.map((input, idx) => {
                return (
                  <GenericInput
                    key={`pricing-${input.name}-${idx}`}
                    {...input}
                    value={pricing[input.name]}
                    onChange={this.onChangePricingProps}
                    disabled={
                      (!creatingMode && (input.name === 'unit' || input.name === 'frequency')) || input.disabled
                      // (isComplexUsage && index > 0)
                    }
                    onClick={input.fa ? () => this.onOpenModal({ name: input.name }) : () => {}}
                  />
                );
              })}
            {!isComplexUsage &&
              this.onRenderSubinputAttribute({
                isComplexUsage,
                subInputUsageAtributeBase,
                dataConfigAttributeBase,
                pricing,
                usageContainerRecordList,
                index,
              })}

            {checkModel === 'USAGE_ATTRIBUTE_BASED' && (
              <div className="col-md-12 pt-3 pb-3 text-center">
                <button
                  type="button"
                  className="button button-border gray x-small"
                  onClick={this.onCopyOldAttributeBase}
                  disabled={index > 0}
                >
                  {`+ ${t('label.addAnotherField')}`}
                </button>
              </div>
            )}
          </div>
          {checkModel !== 'RECURRING_TIERED' && (
            <PricesForm
              item={pricing}
              index={index}
              onChangePrice={this.handleChangePrice}
              onChangeTier={this.handleChangeTier}
              onRemoveItem={this.handleRemovePrice}
              priceRemovable={priceRemovable}
              creatingMode={creatingMode}
              isComplexUsage={isComplexUsage}
              readOnlyCurrency={checkModel === 'USAGE_ATTRIBUTE_BASED' && index > 0}
              {...props}
            />
          )}
          {checkModel === 'RECURRING_TIERED' && (
            <PricesFormRecurringTiered
              item={pricing.tierDiscounting}
              index={index}
              onChangeRecurringPriceStructure={this.onChangeRecurringPriceStructure}
              onChangeTier={this.onChangeTierRecurring}
              onRemoveItem={this.handleRemovePrice}
              priceRemovable={priceRemovable}
              creatingMode={creatingMode}
              isComplexUsage={isComplexUsage}
              {...props}
            />
          )}
        </div>
        <ModalRateUnit
          isOpen={isOpenModalItem === 'rateUnit'}
          onSelect={this.onSelectItem}
          selectedParentId={pricing.rateUnit || null}
          onCancel={() => {
            this.setState({ isOpenModalItem: '' });
          }}
        />
        <ModalTimeUnit
          isOpen={isOpenModalItem === 'timeUnit'}
          onSelect={this.onSelectItem}
          selectedParentId={pricing.timeUnit || null}
          onCancel={() => {
            this.setState({ isOpenModalItem: '' });
          }}
          fieldName="timeUnit"
        />
        <ModalHolidayUnit
          isOpen={isOpenModalItem === 'holidayName'}
          onSelect={this.onSelectItem}
          selectedParentId={pricing.holidayName || null}
          onCancel={() => {
            this.setState({ isOpenModalItem: '' });
          }}
        />
      </div>
    );
  }
}

DiscountForm.propTypes = {
  onChangePricing: PropTypes.func.isRequired,
  pricing: PropTypes.object,
  priceRemovable: PropTypes.bool,
  pricingRemoveable: PropTypes.bool,
  creatingMode: PropTypes.bool,
};

DiscountForm.defaultProps = {
  priceRemovable: true,
  pricingRemoveable: true,
  creatingMode: true,
};
export default withTranslation('common')(DiscountForm);
